import type { LeadSignal } from '../../../../shared/types';
import { provenanceLines, provenanceSummary } from '../../logic/provenance';
import type { ProvenanceLine } from '../../logic/provenance';
import { section } from '../../ui/components';
import { h, span } from '../../ui/dom';

/** "Where this came from" (D96): the public records that named this business, newest first. Read
 *  from the mirror, so it answers on the sidewalk with no signal. */

const row = (line: ProvenanceLine) =>
  h(
    'article',
    { class: `prov${line.origin ? ' prov--origin' : ''}` },
    h(
      'header',
      { class: 'prov__head' },
      span('prov__what', line.what),
      line.origin ? span('prov__tag', 'found here') : null,
    ),
    span('prov__when mono small', line.when),
    line.detail ? h('p', { class: 'prov__detail' }, line.detail) : null,
    line.url
      ? h('a', { class: 'prov__link', href: line.url, target: '_blank', rel: 'noopener' }, 'Open the record')
      : null,
  );

export const provenanceSection = (signals: readonly LeadSignal[], today: string) =>
  section(
    { title: 'Where this came from', count: signals.length || undefined },
    h(
      'div',
      { class: 'card' },
      h('p', { class: 'muted small' }, provenanceSummary(signals)),
      ...provenanceLines(signals, today).map(row),
    ),
  );
